import React from 'react';
import './WaveDivider.css';

const WAVE_PATHS: Record<string, string> = {
  scoopUp: 'M0,80 Q720,0 1440,80 L1440,120 L0,120 Z',
  scoopDown: 'M0,80 Q720,120 1440,80 L1440,120 L0,120 Z',
  multiWave: 'M0,60 Q180,120 360,60 Q540,0 720,60 Q900,120 1080,60 Q1260,0 1440,60 L1440,120 L0,120 Z',
  gentleWave: 'M0,40 Q360,80 720,40 Q1080,0 1440,40 L1440,120 L0,120 Z',
};

interface WaveDividerProps {
  fill?: string;
  variant?: 'scoopUp' | 'scoopDown' | 'multiWave' | 'gentleWave';
  flush?: boolean;
}

function WaveDivider({ fill = '#f5f2eb', variant = 'scoopUp', flush = false }: WaveDividerProps): React.ReactElement {
  const path = WAVE_PATHS[variant] ?? WAVE_PATHS.scoopUp;
  return (
    <div className={`wave-divider ${flush ? 'wave-divider-flush' : ''}`} aria-hidden="true">
      <svg
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d={path} fill={fill} />
      </svg>
    </div>
  );
}

export default WaveDivider;
